import { render, staticRenderFns } from "./abnormalRecord.vue?vue&type=template&id=6ac7ba59&scoped=true&"
import script from "./abnormalRecord.vue?vue&type=script&lang=js&"
export * from "./abnormalRecord.vue?vue&type=script&lang=js&"
import style0 from "./abnormalRecord.vue?vue&type=style&index=0&id=6ac7ba59&lang=scss&scoped=true&"
import style1 from "./abnormalRecord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac7ba59",
  null
  
)

export default component.exports